 import { morphSection, sectionRenderer } from '@theme/section-renderer';
const originalRenderSection = sectionRenderer.renderSection;

sectionRenderer.renderSection = async function (sectionId) {
  const result = await originalRenderSection.call(this, sectionId);

  const sectionEl = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (sectionEl) {
    // 🔥 Dispatch a custom event or call your function here
    sectionEl.dispatchEvent(new CustomEvent('section:rendered', {
      detail: { id: sectionId },
      bubbles: true 
    }));

    // console.log(`✅ Section rendered: ${sectionId}`);
  }

  return result;
}